var _circle, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemoteControl(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#DA5042"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 8,
    width: 22,
    height: 50,
    rx: 6,
    fill: "#271E1F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 13,
    width: 6,
    height: 4,
    rx: 2,
    fill: "#A9BECD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 21,
    width: 6,
    height: 4,
    rx: 2,
    fill: "#A9BECD"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 29,
    width: 6,
    height: 4,
    rx: 2,
    fill: "#A9BECD"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 13,
    width: 6,
    height: 4,
    rx: 2,
    fill: "#A9BECD"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 21,
    width: 6,
    height: 4,
    rx: 2,
    fill: "#A9BECD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.3094 54.77C66.3094 54.99 66.3094 55.22 66.2994 55.44C65.8894 56.09 65.4594 56.72 64.9994 57.33C64.7394 57.69 64.4694 58.04 64.1894 58.39C63.8094 58.87 63.4094 59.35 62.9994 59.81C61.0594 62.01 58.8594 63.97 56.4394 65.64C56.2594 65.77 56.0794 65.89 55.8894 66.01C53.6194 67.52 51.1594 68.78 48.5594 69.75C47.9794 69.96 47.3994 70.16 46.8094 70.35C44.5294 71.07 42.1494 71.56 39.6894 71.81C39.4394 71.84 39.1894 71.86 38.9394 71.88C38.9094 71.88 38.8694 71.89 38.8394 71.89C37.8994 71.96 36.9594 72 35.9994 72C35.3294 72 34.6594 71.98 33.9994 71.94C32.6594 71.87 31.3494 71.73 30.0594 71.51C28.6194 71.27 27.2094 70.95 25.8394 70.54L25.6194 70.15L14.1094 50.21C12.6394 47.68 13.5094 44.43 16.0494 42.97C16.8894 42.49 17.7994 42.26 18.6994 42.26C20.5294 42.26 22.3094 43.21 23.2994 44.91L26.9194 51.18C27.3094 50.53 27.7494 49.92 28.2094 49.35C28.7794 48.65 29.3994 48.01 30.0594 47.44V26.81C30.0594 24.15 32.2094 22 34.8694 22C36.1994 22 37.4094 22.54 38.2794 23.41C39.1394 24.27 39.6894 25.48 39.6894 26.81V41.74C40.5394 40.39 42.0394 39.5 43.7494 39.5C45.0794 39.5 46.2794 40.04 47.1494 40.91C47.3494 41.11 47.5294 41.32 47.6894 41.55C48.5494 40.31 49.9994 39.5 51.6194 39.5C52.9494 39.5 54.1594 40.04 55.0294 40.91C55.1994 41.08 55.3594 41.26 55.4994 41.46C56.3794 40.27 57.7894 39.5 59.3694 39.5C60.6994 39.5 61.8994 40.04 62.7794 40.91C62.9594 41.09 63.1194 41.28 63.2594 41.48C63.2694 41.43 63.2894 41.38 63.2994 41.34C63.9094 42.02 64.4594 43.1 64.9194 44.49C65.7794 47.08 66.3094 50.73 66.3094 54.77Z",
    fill: "#EEC98A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoteControl);
export default __webpack_public_path__ + "static/media/remote-control.d6bd76aa1d8bef1238a48d717117ca38.svg";
export { ForwardRef as ReactComponent };